import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { PopupEvent } from 'webapp/enums/enums';

export default class ClientsAccountsNewRoute extends Route {
	@service('account') declare accountService: Service.Account;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('model-manager/spaces') declare mmSpacesService: Service.ModelManager.Spaces;

	override beforeModel(): void {
		if (!this.accountService.canAddClient) {
			this.navigationService.replaceRoute('clients.accounts');
		}
	}

	override afterModel(): void {
		const popup = this.mmSpacesService.openCreateClientPopup('clients'); // TrackingOriginTypeForNewClientForm

		popup?.on(PopupEvent.CLOSING, this, () => {
			if (this.navigationService.activatedRoute.startsWith('clients')) {
				this.navigationService.transitionToRoute('clients.accounts');
			}
		});
	}
}
